<template>
  <div class="serviceDetails">
    <template v-if="ifShow">          
      <div class="banner">
        <div class="w" style="position: relative">
          <div class="ban_l">
            <div class="tit">{{serviceDetails.serviceManage.serviceManageName}}</div>
            <div class="desc">{{serviceDetails.serviceManage.description}}</div>
            <div class="flex">
              <div class="bon_col flex">
                <div :class="['flex',serviceDetails.serviceManage.isApply?'handle':'disable_class']" @click="gotoWork">
                  <img src="../../assets/icon/icon-handle.png" v-if="serviceDetails.serviceManage.isApply" alt="" />
                  {{serviceDetails.serviceManage.isApply?'线上办理':'线下办理'}}
                </div>
                <div class="flex" @click="addColl">
                  <img
                    src="../../assets/icon/icon-collection.png"
                    alt=""
                  />加入收藏
                </div>
                <div class="flex">
                  <img src="../../assets/icon/icon-evaluate.png" alt="" />我要评价
                </div>
              </div>
              <div class="rate">
                <span>满意度</span><a-rate :default-value="4" disabled />
                <div class="flex">
                  <div style="margin-right: 2%"><span>热度值：</span>{{serviceDetails.serviceManage.heatValue}}</div>
                  <div><span>收藏量：</span>{{serviceDetails.serviceManage.collectValue}}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="ban_r"></div>
        </div>
      </div>
      <div class="w tit_p">
        当前位置：<span @click="returnFn">服务大厅</span>
        <img src="../../assets/icon/icon-right.png" alt="" />
        {{ serviceDetails.serviceManage.departmentName }}
        <img src="../../assets/icon/icon-right.png" alt="" />
        {{serviceDetails.serviceManage.serviceManageName}}
      </div>

      <!-- 表格内容 -->
      <div class="w flex" style="align-items:normal;">
        <div class="table_out">
          <!-- 图片标签 -->
          <!-- <div class="img_tag">
            <img class="img_tag1" v-if="serviceDetails.serviceManage.priority == 1" src="../../assets/icon/icon-new.png" alt="">
            <img class="img_tag2" v-if="serviceDetails.serviceManage.priority == 2" src="../../assets/icon/icon-recommend.png" alt="">
            <img class="img_tag3" v-if="serviceDetails.serviceManage.serviceTimeLimit.length>0" src="../../assets/icon/icon-time-limit.png" alt="">
          </div> -->
          <div class="con_tit" id="base_info">基本信息</div>
          <div class="table_bd">
            <div class="flex table_line">
              <!-- <div class="flex table_box">
                <div class="table_label">事项名称：</div>
                <div class="table_value">{{serviceDetails.serviceManage.serviceManageName}}</div>
              </div> -->
              <div class="flex table_box" style="width:100%">
                <div class="table_label" style="flex: 1.332">主管部门：</div>
                <div class="table_value" style="flex: 9">{{serviceDetails.serviceManage.departmentName}}</div>
              </div>
              <div class="flex table_box">
                <div class="table_label">事项类型：</div>
                <div class="table_value">{{serviceDetails.serviceManage.manageType == 1 ? '办事类' : '应用类'}}</div>
              </div>
              <div class="flex table_box">
                <div class="table_label">所属分类：</div>
                <div class="table_value">
                  <span v-for="(item,idx) in serviceDetails.serviceManage.serviceClassifyName" :key="idx">{{ item }}&nbsp;&nbsp;</span>
                </div>
              </div>
              <!-- <div class="flex table_box">
                <div class="table_label">业务主题：</div>
                <div class="table_value">
                  <div v-if="serviceDetails.serviceManage.themeNameList.length==0">暂无</div>
                  <template v-else>
                    <a-space v-for="(item,idx) in serviceDetails.serviceManage.themeNameList" :key="idx">{{ item }}</a-space>
                  </template>
                </div>
              </div> -->
              <div class="flex table_box">
                <div class="table_label">服务对象：</div>
                <div class="table_value">
                  <span v-for="item in serviceDetails.serviceManage.targets" :key="item">{{item}}&nbsp;</span>
                </div>
              </div>
              <!-- <div class="flex table_box">
                <div class="table_label">服务终端：</div>
                <div class="table_value flex">
                  <div class="flex" v-if="serviceDetails.serviceManage.terminal != 1"><img src="../../assets/icon-mobile-outline.png" alt="">手机</div>
                  <div class="flex" :style="serviceDetails.serviceManage.terminal != 1?'margin-left: 16px;':''" v-if="serviceDetails.serviceManage.terminal != 2"><img src="../../assets/icon-pc-outline.png" alt="">电脑</div>
                </div>
              </div> -->
              <!-- <div class="flex table_box">
                <div class="table_label">匿名服务：</div>
                <div class="table_value">{{serviceDetails.serviceManage.anon==0?'匿名':'不匿名'}}</div>
              </div> -->
              <div class="flex table_box">
                <div class="table_label">服务地点：</div>
                <div class="table_value">{{serviceDetails.serviceManage.address}}</div>
              </div>
              <div class="flex table_box">
                <div class="table_label">服务时间：</div>
                <div class="table_value">法定工作日{{serviceDetails.serviceManage.serviceTime}}</div>
              </div>
              <div class="flex table_box">
                <div class="table_label">服务热线：</div>
                <div class="table_value">{{serviceDetails.serviceManage.hotLine}}</div>
              </div>
              <div class="flex table_box">
                <div class="table_label">服务方式：</div>
                <div class="table_value">{{serviceDetails.serviceManage.way==1?'线上':serviceDetails.serviceManage.way==0?'线上&线下':'线下'}}</div>
              </div>
              <div class="flex table_box">
                <div class="table_label">办理时限：</div>
                <div class="table_value">
                  <div>{{ serviceDetails.serviceManage.serviceTimeLimit }}</div>
                </div>
              </div>
              <!-- <div class="flex table_box">
                <div class="table_label">跑腿次数：</div>
                <div class="table_value">
                  <div v-if="serviceDetails.serviceManage.runNum==0">无需跑腿</div>
                  <div v-else>{{ serviceDetails.serviceManage.runNum }}次</div>
                </div>
              </div> -->
            </div>
          </div>
          <div class="con_tit" id="service_content">服务内容</div>
          <div class="table_con" v-html="serviceDetails.serviceProcessVo.content"></div>
          <div class="con_tit"  id="service_process">附表一</div>
          <div class="pres">
            <div style="text-align: left;" v-html="serviceDetails.serviceProcessVo.process"></div>
          </div>
          <div class="con_tit"  id="service_asquestion">附表二</div>
          <div class="pres">
            <div style="text-align: left;" v-html="serviceDetails.serviceProcessVo.askQuestion"></div>
          </div>
          <div class="con_tit" id="file">相关材料</div>
          <a v-for="item in serviceDetails.serviceMaterialVo" :key="item.id" :href="imgPrefix+item.materialId" :download="item.name" class="file_class" >
            {{ item.name }}.{{ item.suffix }}
          </a>
          <div style="text-align: left;" v-if="serviceDetails.serviceMaterialVo.length==0">暂无</div>
        </div>
        <!-- 右侧描点栏 -->
        <a-anchor :showInkInFixed="true" :target-offset="targetOffset" style="flex:1;">
          <a-anchor-link href="#base_info" title="基本信息" />
          <a-anchor-link href="#service_content" title="服务内容" />
          <a-anchor-link href="#service_process" title="附表一" />
          <a-anchor-link href="#service_asquestion" title="附表二" />
          <a-anchor-link href="#file" title="相关材料" />
        </a-anchor>
      </div>
    </template>
    <template v-else>
      <a-spin style="height: 100vh;" />
    </template>
  </div>
</template>

<script>

import {findServiceManageDetailByIdApi} from '@/api/index'
import imgPrefix from '../../../utils/imgPrefix';
import {targetsFn} from '../../../utils/utils'
export default {
  props: {},
  components: {},
  data() {
    return {
      serviceDetails:{},
      ifShow:false,
      targetOffset: undefined,
      manageId:'',
      imgPrefix,
    };
  },
  computed: {},
  watch: {},
  created() {
    // console.log(this.$route.query,'-----');    
    this.manageId = this.$route.query.serviceManageId;
    this.findServiceManageDetailById()

  },
  mounted() {
    // 更改描点到浏览器顶部的位置
    // this.targetOffset = window.innerHeight / 3;
  },
  methods: {
    // 获取详情
    findServiceManageDetailById(){
      findServiceManageDetailByIdApi(this.manageId).then(res => {
        console.log(res,'获取详情');
        // res.serviceManage.targets = res.serviceManage.targets?.split(',');
        // [0]全部,[1]学生,[2]教师,[3]游客,[4]上级部门,[5]同级部门,[6]部门内部,[7]其他
        let strArr = res.serviceManage.targets?.split(',') || [];
        res.serviceManage.targets = targetsFn(strArr);
        
        this.serviceDetails = res;
        this.ifShow = true;
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 办理
    gotoWork(){
      if(this.serviceDetails.serviceManage.isApply){
        window.open(this.serviceDetails.serviceManage.pcUrl);
      }
    },
    // 收藏
    addColl(){
      window.open('https://portal.ly-sky.com:6208/#/login')
    },
    returnFn(){
      // this.$router.go(-1)
      let naviTop = JSON.parse(sessionStorage.getItem('naviArr'))
      naviTop.forEach(item => {
        if(item.link == '/serviceHall'){
          this.$router.push('/serviceHall?naviId='+item.id)
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
.serviceDetails {
  .banner {
    width: 100%;
    height: 17rem;
    background: url("../../assets/banner-color.png") no-repeat center;
    background-size: cover;
    text-align: left;
    margin-bottom: 37px;
    .ban_l {
      flex: 1;
      margin-top: 0;
      width: 65%;
      .tit {
        font-weight: 900;
        font-size: 40px;
        margin-bottom: 1%;
        padding-top: 48px;
      }
      .desc {
        font-size: 14px;
        color: #7a8ba4;
        -webkit-line-clamp: 3;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .bon_col {
        margin-top: 24px;
        margin-right: 4%;
        div {
          border-radius: 8px;
          padding: 0.8rem 0.85rem;
          font-size: 18px;
          background: #fff;
          margin-right: 12px;
          cursor: pointer;
          img {
            margin-right: 10px;
          }
        }
        .handle {
          background: var(--themeColor);
          color: #fff;
        }
      }
      .rate {
        font-size: 14px;
        flex: 1;
        span {
          color: #7a8ba4;
        }
        div {
          color: var(--themeColor);
        }
      }
    }
    .ban_r {
      width: 43%;
      height: 272px;
      background: url("../../assets/sevice.png") no-repeat right;
      position: absolute;
      top: -4%;
      right: 0%;
    }
  }
  .tit_p {
    text-align: left;
    color: #7a8ba4;
    opacity: 0.8;
    margin-bottom: 1.8rem;
    img {
      margin: 0 2px 2px 2px;
    }
    span{
      cursor: pointer;
    }
  }
  .table_out {
    border: 1px solid #e0e5f0;
    padding: 28px 24px;
    margin-bottom: 8rem;
    margin-right: 12px;
    // width: 80%;
    flex: 9;
    position: relative;
    .con_tit {
      font-size: 18px;
      padding-bottom: 16px;
      margin-bottom: 18px;
      border-bottom: 1px solid #e0e5f0;
      text-align: left;
    }
    .file_class{      
      text-align: left;
      display: block;
    }
    // .file_class:hover{
    //   color: var(--themeColor);
    // }
    .table_bd {
      border-top: 1px solid #e0e5f0;
      border-left: 1px solid #e0e5f0;
      max-width: 62.5rem;
      overflow: hidden;
      margin-bottom: 2.5rem;
      .table_line {
        flex-wrap: wrap;
        width: 100%;
        align-content: flex-start;
        .table_box {
          border-bottom: 1px solid #e0e5f0;
          border-right: 1px solid #e0e5f0;
          width: 50%;
        }
        .table_label {
          background: #ebeffc;
          flex: 3;
          padding: 14px 34px;
        }
        .table_value {
          flex: 7;
          text-align: left;
          padding: 3px 26px;
          img{
            width: 18px;
            margin-right: 6px;
          }
        }
      }
    }
    .img_tag{     
      .img_tag1{
        position: absolute;
        top: -4px;
        right: 15%;
      }
      .img_tag2{
        position: absolute;
        top: -4px;
        right: 26%;
      }
      .img_tag3{
        position: absolute;
        top: -11px;
        right: -1%;
      }
    }
  }
  .table_con{
    text-align: left;
    margin-bottom: 4.31rem;
  }
  .pres{
    margin-bottom: 5rem;
    img{
      max-width: 35.8rem;
    }
  }
  .file{
    text-align: left;
  }
}
/deep/.ant-anchor-link-active{
  // padding-left: 0;
  background: linear-gradient(90deg, #EBEFFC 0%, rgba(235, 239, 252, 0) 100%);
}
/deep/.ant-anchor-ink-ball{
  width: 0;
  height: 0;
  border: none;
}
</style>
